import { ClearRefinements } from 'react-instantsearch'

import type { ReactElement } from 'react'
import type { ClearRefinementsProps } from 'react-instantsearch'

import './styles.scss'

const AlgoliaClearRefinements = (props: ClearRefinementsProps): ReactElement => {
  return (
    <ClearRefinements
      {...props}
      className="custom-clear-refinements"
      classNames={{ button: 'custom-clear-refinements__button' }}
      translations={{
        resetButtonText: 'Clear all',
      }}
    />
  )
}

export default AlgoliaClearRefinements
